<template>
    <b-container>

        <div class="breadcrumb-class">
            <b-breadcrumb class="breadCrumb">
                <router-link :to="`/admin/reporting`"> Reporting Dashboard </router-link>
                <router-link :to="`/admin/reporting/client/${this.$route.params.id}`"> /{{ clientName }} </router-link>
                <b-breadcrumb-item active> /Weekly Challenge </b-breadcrumb-item>
            </b-breadcrumb>
            <b-row>

                <b-col cols=12 md=auto class="mt-3">
                    <div class="d-flex flex-row align-items-center">
                        <label class="filter-label" :for="'fromDate'">From</label>
                        <div class="ml-2 w-100 px-4 px-md-1">
                            <b-form-datepicker :date-format-options="dateFormatOption" :min="minFromDate" :max="maxFromDate"
                                class="filter-date-input-white notranslate" :id="'fromDate'" type="date" v-model="fromDate">
                            </b-form-datepicker>
                        </div>
                    </div>
                </b-col>

                <b-col cols=12 md=auto class="mt-3 date-picker-div">
                    <div class="d-flex flex-row align-items-center">
                        <label class="filter-label" :for="'toDate'">To</label>
                        <div class="ml-2 w-100 px-4 px-md-1">
                            <b-form-datepicker :date-format-options="dateFormatOption" :min="minToDate" :max="maxToDate"
                                class="filter-date-input-white notranslate" :id="'toDate'" type="date" v-model="toDate">
                            </b-form-datepicker>
                        </div>
                    </div>
                </b-col>

                <b-col md=auto class="date-div">
                    <b-button class="date-button" variant="primary" @click="dateFilter">Apply</b-button>
                </b-col>

                <b-col cols=4 class="date-div">
                    <b-button class="clear-button" variant="secondary" @click="clearDateFilter">Clear</b-button>
                </b-col>

                <b-col class="download-button-col">
                    <b-dropdown text="Download CSV" variant="info" class="download-dropdown">
                        <b-dropdown-item-button class="download-dropdown-button" @click="downloadCSV(false)">Download this
                            page</b-dropdown-item-button>
                        <b-dropdown-item-button @click="downloadCSV(true)">Download all rows</b-dropdown-item-button>
                    </b-dropdown>
                </b-col>

            </b-row>
        </div>

        <div class="card border-0">
            <div class="card-body px-0 rounded overflow-auto">
                <div class="b2b-table">
                    <b-table hover :items="rows" :busy="isLoading">
                    </b-table>
                </div>
            </div>

            <div class="pagination">
                <Multiselect :options="pageSizeArray" v-model="pageSize" class="pageSizeMS" />
                <b-pagination v-model="page" :total-rows="totalRecords" :per-page="pageSize" />
            </div>
        </div>



    </b-container>
</template>

<script>
import API from "../api.js"
import Multiselect from 'vue-multiselect';
import router from "@/router";
export default {
    name: "ReportingDashboard",
    data() {
        return {
            minFromDate: undefined,
            maxFromDate: undefined,
            minToDate: undefined,
            maxToDate: undefined,
            fromDate: '',
            toDate: '',
            dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
            rows: [],
            pageSize: 20,
            page: 1,
            pageSizeArray: [10, 20, 50, 100],
            totalRecords: 0,
            tenantId: this.$route.params.id,
            clientName: ''
        }
    },

    methods: {

        formatDate(isoDateString) {
            const date = new Date(isoDateString);
            const formattedDateString = date.toLocaleString("en-US", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
            });
            return formattedDateString;
        },

        dateFilter() {
            this.weeklyChallenge()
        },

        async clearDateFilter() {
            this.fromDate = '';
            this.toDate = '';
        },

        async downloadCSV(downloadAll) {

            const downloadCSVParam = {
                tenantId: this.tenantId,
                startDate: this.fromDate,
                endDate: this.toDate,
                minWorkoutMin: 0,
                minWorkoutDur: 5,
                minWorkoutDay: 5,
                perPage: downloadAll ? this.totalRecords : this.pageSize,
                page: this.page,
                resType: 'CSV',
            }


            try {
                let data = await API.weeklyChallenge(downloadCSVParam)

                const blob = new Blob([data], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.setAttribute('href', url)
                a.setAttribute('download', 'WeeklyChallenge.csv');
                a.click()
            }
            catch (error) {
                console.log("There is an error in Downloading CSV", error);
            }
        },

        async weeklyChallenge() {
            const weeklyChallengeParam = {
                tenantId: this.tenantId,
                startDate: this.fromDate,
                endDate: this.toDate,
                minWorkoutMin: 0,
                minWorkoutDur: 5,
                minWorkoutDay: 5,
                perPage: this.pageSize,
                page: this.page
            }

            try {
                let res = await API.weeklyChallenge(weeklyChallengeParam)
                this.fromDate = res.startDate;
                this.toDate = res.endDate;
                this.rows = []
                res.data.rows.forEach((item) => {
                    this.rows.push({
                        signup_date: this.formatDate(item.signUpDate),
                        email: item.email,
                        mobile: item.mobileNo,
                        total_workouts: item.totalWorkouts,
                        number_of_daily_challenges_completed: item.noOfDailyChallangeCompleted,
                        weekly_challenge_completed: item.weeklyChallangeCompleted
                    });
                });

                this.totalRecords = res.data.total
                this.clientName = res.data.rows[0].corporate
            }
            catch (error) {
                console.log("There is an error in weeklyChallenge", error);
            }
        },
    },
    watch: {
        fromDate: function (val) {
            ''
            this.minToDate = new Date(val);
        },
        toDate: function (val) {
            this.maxFromDate = new Date(val);
        },
        page() {
            this.weeklyChallenge();
        },
        pageSize() {
            if (this.pageSize !== 0) {
                this.weeklyChallenge();
            }
        },
    },

    components: {
        Multiselect
    },
    mounted() {
        this.weeklyChallenge()
    }
}
</script>


<style lang="scss" scoped>
// Multiselect
::v-deep .multiselect__tags {
    min-height: 0;
    padding: 0;
    background: #FFFFFF !important;
    border: 2px solid #73BC44;
    border-radius: 5px !important;
    height: 34px !important;
    min-width: 135px !important;
    display: flex;
    align-items: center;
}

::v-deep .multiselect__placeholder {
    margin: 5px 0 5px 10px;
    color: #969B92;
    font-weight: 500;
}

::v-deep .multiselect__single {
    margin-bottom: 0px !important;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #141513 !important;
}

::v-deep .multiselect__select:before {
    color: #73BC44 !important;
    border-color: #73BC44 transparent transparent;
}

::v-deep .multiselect__tags-wrap {
    display: flex !important;
    align-items: center !important;
}

::v-deep .multiselect__tag {
    margin-bottom: 0;
}

// Card Body

.card {
    border: none;
    background-color: #323232;
    margin-top: 20px;

    .card-body {
        position: relative;
        padding-bottom: 20px;
        margin-bottom: 30px;
    }
}

// Breadcrumbs
.breadCrumb {
    background-color: #323232;
}

/* Date Picker and Buttons */

.filter-label {
    top: 50%;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    color: white;
}

.date-picker-div {
    padding-left: 0px;
    padding-right: 10px;
}

.date-div {
    padding-left: 10px;
}

.date-button {
    margin-top: 15px;
    height: 35px;
}

.clear-button {
    margin-top: 15px;
    height: 35px;
}

// Download Button
.download-button-col {
    text-align: right;
}

.download-dropdown {
    margin-top: 10px;
}

// Pagination
.pageSizeMS {
    width: 200px;
    margin-left: 10px;
    margin-right: 25px;
}
</style>